import React from 'react';
import PropTypes from 'prop-types';
import { getSectionColor, getSectionAbbr } from 'utils/Formatters';

const ASQSectionResults = ({ survey }) => {
  if (!survey.sections) return null;
  const items = survey.sections.map(section => {
    const name = survey.type === 'asq_3' ? getSectionAbbr(section.nameEn) : section.score.result;
    const colorKey = section.score.resultKey || section.score.result;
    return name ? { name, colorKey, key: section.name } : null;
  }).filter(Boolean);

  return (
    <>
      {items.map(item => (
        <span key={item.key} className={`cs-txt--sp-${getSectionColor(item.colorKey)}`}>
          {item.name}{' '}
        </span>
      ))}
    </>
  );
}

ASQSectionResults.propTypes = {
  survey: PropTypes.object.isRequired,
}

export default ASQSectionResults;
